import {
  createApi,
  createFileApi,
  createImgApi,
  createDownApi,
  createUploadApi,
  createSerachImageApi
} from '@/utils/apiWrap'

// TODO
// 访问本地后端
// const BASE_URL = 'http://localhost:8081/obia/api'
// 访问服务器
const BASE_URL = '/obia/api'
// const BASE_URL = 'http://192.168.164.104:8000/obia/api'
// 访问 nginx
// const BASE_URL = 'http://localhost:8080/obia/api'

// token 操作
export const updateToken = (data) => createApi(BASE_URL + '/updateToken', 'post', data)

// 获取登陆用户的所有信息
export const getLoginInfo = (data) => createApi(BASE_URL + '/getUserInfo', 'post', data)

// 获取 email
// export const getLoginEmail = (data) => createApi(BASE_URL + '/user-info', 'post', data)
// 获取用户信息
// export const getUserInfo = (data) => createApi(BASE_URL + '/user/getInfoByEmail', 'post', data)

// Home
export const getHomeNumber = (data) => createApi(BASE_URL + '/getHomeNumber', 'get', data)

// Browse
export const getLeftMenu = (data) => createApi(BASE_URL + '/browse/left-menu', 'get', data)
export const filterIndividual = (data) => createApi(BASE_URL + '/browse/filterIndividual', 'post', data)
export const filterStudy = (data) => createApi(BASE_URL + '/browse/filterStudy', 'post', data)
export const filterImage = (data) => createApi(BASE_URL + '/browse/filterImage', 'post', data)

// 图像检索
export const searchImage = (data) => createApi(BASE_URL + '/browse/searchImage', 'post', data)

// Collection
export const getAllCollection = (data) => createApi(BASE_URL + '/collection/getAllCollection', 'get', data)
export const getCollectionDetail = (data) => createApi(BASE_URL + '/collection/getCollectionDetail', 'post', data)
// export const getIndividualTable = (data) => createApi(BASE_URL + '/collection/getIndividualTable', 'post', data)
export const getIndividualTable = (data) => createApi(BASE_URL + '/collection/getIndividualTableNew', 'post', data)
export const getCollectionByAccession = (data) => createApi(BASE_URL + '/collection/getInfoByAccession', 'post', data)
export const getStudyByCollection = (data) => createApi(BASE_URL + '/collection/getStudyByCollection', 'post', data)

// Individual
export const getIndividualDetail = (data) => createApi(BASE_URL + '/individual/getIndividualDetail', 'post', data)
export const getStudyTable = (data) => createApi(BASE_URL + '/individual/getStudyTable', 'post', data)
export const getSeriesTable = (data) => createApi(BASE_URL + '/study/getSeriesTable', 'post', data)

// Statistics
export const getAnatomicalSiteNumber = (data) => createApi(BASE_URL + '/getAnatomicalSiteNumber', 'get', data)
export const getDiseaseNumber = (data) => createApi(BASE_URL + '/getDiseaseNumber', 'get', data)
export const getModalityNumber = (data) => createApi(BASE_URL + '/getModalityNumber', 'get', data)

// Request
export const getRequestCollection = (data) => createApi(BASE_URL + '/request/getRequestCollection', 'post', data)
// new
export const getRequestDetail = (data) => createApi(BASE_URL + '/request/getRequestDetail', 'post', data)
export const updateRequest = (data) => createApi(BASE_URL + '/request/updateRequest', 'post', data)
export const newRequest = (data) => createApi(BASE_URL + '/request/newRequest', 'post', data)
// view
export const getSubmitRequest = (data) => createApi(BASE_URL + '/request/getSubmitRequest', 'post', data)
export const getReceiveRequest = (data) => createApi(BASE_URL + '/request/getReceiveRequest', 'post', data)
// submit 操作
export const deleteRequest = (data) => createApi(BASE_URL + '/request/deleteRequest', 'post', data)
export const sendEmail = (data) => createApi(BASE_URL + '/request/sendEmail', 'post', data)
// receive 操作
export const approveRequest = (data) => createApi(BASE_URL + '/request/approveRequest', 'post', data)
export const rejectRequest = (data) => createApi(BASE_URL + '/request/rejectRequest', 'post', data)

// viewer
export const getSeriesThumbnail = (data) => createApi(BASE_URL + '/getSeriesThumbnail', 'post', data)
export const getStudyThumbnail = (data) => createApi(BASE_URL + '/getStudyThumbnail', 'post', data)

// submit
export const newSubmission = (data) => createApi(BASE_URL + '/submit/newSubmission', 'post', data)
export const getSubmission = (data) => createApi(BASE_URL + '/submit/getSubmission', 'post', data)
export const getSubmitDetail = (data) => createApi(BASE_URL + '/submit/getSubmitDetail', 'post', data)
export const deleteSubmission = (data) => createApi(BASE_URL + '/submit/deleteSubmission', 'post', data)
export const updateSubmission = (data) => createApi(BASE_URL + '/submit/updateSubmission', 'post', data)
export const shareSubmission = (data) => createApi(BASE_URL + '/submit/shareSubmission', 'post', data)
export const cancelShareUrlBack = (data) => createApi(BASE_URL + '/submit/cancelShareUrl', 'post', data)
export const releaseSubmission = (data) => createApi(BASE_URL + '/submit/releaseSubmission', 'post', data)

// 根据 casID 检查 prjAccession 返回  true false
export const checkPrjAccession = (data) => createApi(BASE_URL + '/checkPrjAccession', 'post', data)

export const checkRandomCode = (data) => createApi(BASE_URL + '/collection/checkRandomCode', 'post', data)
export const getCollectionDetailPreview = (data) => createApi(BASE_URL + '/collection/preview/getCollectionDetail', 'post', data)
export const getIndividualTablePreview = (data) => createApi(BASE_URL + '/collection/preview/getIndividualByCollection', 'post', data)
export const getStudyByCollectionPreview = (data) => createApi(BASE_URL + '/collection/preview/getStudyByCollection', 'post', data)



// WEBPACK FOOTER //
// ./src/api/index.js